import { render, staticRenderFns } from "./HistoryItemTypePreorder.vue?vue&type=template&id=74324cde&scoped=true&"
import script from "./HistoryItemTypePreorder.vue?vue&type=script&lang=js&"
export * from "./HistoryItemTypePreorder.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemTypePreorder.vue?vue&type=style&index=0&id=74324cde&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74324cde",
  null
  
)

export default component.exports